import React from "react";
import { Sparkles } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function Login() {
  const handleLogin = () => {
    const redirectUrl = window.location.origin + "/admin/callback";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen theme-dark grain flex items-center justify-center p-6 relative overflow-hidden">
      <div className="shape-blob bg-accent-yellow w-[400px] h-[400px] top-0 left-0 opacity-30" />
      <div className="shape-blob bg-accent-orange w-[400px] h-[400px] bottom-0 right-0 opacity-30" />
      <div className="relative max-w-md w-full">
        <div className="font-display text-5xl tracking-tighter mb-2">places<span className="text-accent-orange">.</span></div>
        <div className="text-xs uppercase tracking-widest text-neutral-400 mb-8">CMS / Painel admin</div>
        <h1 className="font-display text-4xl leading-tight mb-3">Acesso restrito.</h1>
        <p className="text-neutral-400 mb-10 text-sm">Faça login com a conta Google autorizada para gerenciar todo o conteúdo do site.</p>
        <button onClick={handleLogin} data-testid="login-google" className="w-full bg-accent-yellow text-black px-6 py-4 font-semibold flex items-center justify-center gap-3 rounded-full hover:bg-white transition">
          <Sparkles className="w-4 h-4" />
          Entrar com Google
        </button>
        <div className="mt-6 text-xs text-neutral-500">Apenas o e-mail autorizado pode acessar.</div>
      </div>
    </div>
  );
}
